import { render, staticRenderFns } from "./UpdateDataSummary.vue?vue&type=template&id=0003536e&scoped=true"
import script from "./UpdateDataSummary.vue?vue&type=script&lang=js"
export * from "./UpdateDataSummary.vue?vue&type=script&lang=js"
import style0 from "./UpdateDataSummary.vue?vue&type=style&index=0&id=0003536e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003536e",
  null
  
)

export default component.exports